import { FC } from "react";
import { PageHeader } from "../../components/PageHeader";
import { Compare } from "../../modules/Compare";

export const ComparePage: FC = () => {
  return (
    <div>
      <PageHeader
        header="Compare environments"
        description="Choose environments and option to compare"
      />
      <Compare />
    </div>
  );
};
